import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { Estate } from '@/modules/estate/models/Estate';
import { Asset } from '@/modules/asset/models/Asset';
import { Liability } from '@/modules/liability/models/Liability';
import { Document } from '@/modules/document/models/Document';
import { ModelType } from '@/modules/core/app/constants/ModelType';

export type SpotlightItem = Estate | Document | Asset | Liability;
export type SpotlightItems = Estate[] | Document[] | Asset[] | Liability[];

export class SpotlightGroup extends BaseModel {
  type: ModelType;
  items: SpotlightItems;

  constructor(model: Partial<SpotlightGroup> = {}) {
    super();

    this.type = model.type as ModelType;
    this.items = model.items ?? [];
  }
}
